import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  containerModal: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.4)',
    justifyContent: 'center',
    paddingHorizontal: 20,
  },
  containerCard: {
    width: '95%',
    backgroundColor: 'white',
    alignSelf: 'center',
    borderRadius: 16,
    paddingVertical: 25,
    paddingHorizontal: 20,
    flexDirection: 'column',
    justifyContent: 'space-between',
    maxHeight: '80%',
  },
  title: {
    fontSize: 20,
    lineHeight: 26,
    color: 'black',
    textAlign: 'center',
    fontFamily: 'TCCC-UnityText Bold',
    marginBottom: 16,
  },
  body: {
    fontSize: 16,
    lineHeight: 22,
    color: '#4a4a4a',
    textAlign: 'center',
    fontFamily: 'TCCC-UnityText Bold',
    marginBottom: 24,
  },
  buttonWrapper: {
    paddingHorizontal: 25,
    alignItems: 'center',
  },
  secondaryButtonWrapper: {
    paddingHorizontal: 25,
    alignItems: 'center',
    marginTop: 12,
  },
});
